import React, { useState, useEffect } from 'react';
// import './Orders.css';
import { useNavigate } from 'react-router-dom';
import WhiteScreen from '../../components/MainPage/WhiteScreen';
import Hero from '../../components/MainPage/Hero';
import Layout from '../../layouts/Layout';
import ChargesScreen from '../../components/MainPage/ChargesScreen';
import CommentsScreen from '../../components/MainPage/CommentsScreen';
import Location from '../../components/MainPage/Location';
import News from '../../components/MainPage/News';
import Navbar from '../../components/Navbar';

function MainPage() {
    const navigate = useNavigate();
    


  // If you want to check for the "Admin" role, do so here


  // If you have a 'role.access' array with permissions from your JSON

  return (

    <div> 

        
        <Layout>

            {/* <Hero /> */}
            <WhiteScreen />
            <ChargesScreen />
            <CommentsScreen />
            <Location />
            <News />
        </Layout>


    </div>
  );
}

export default MainPage;
